export default () => {
    const decodedCfg = window.slwCfg ? JSON.parse(Buffer.from(window.slwCfg, 'base64').toString('utf8')) : undefined
    const customerName = decodedCfg ? decodedCfg.slwCustomerName || 'xlite-web' : 'SLware'
    const apiVersion = decodedCfg ? `B${decodedCfg.slwApiVersion}` : ''
    const devSuffix = process.env.VUE_APP_ARGV.split(',').includes('--dev') ? '-dev' : ''
    const appVersion = `F${process.env.VUE_APP_VERSION}${devSuffix}`
    const bundleVersion = decodedCfg ? `v${decodedCfg.slwBundleVersion}` : appVersion
    const version = `${bundleVersion}`
    const detailedVersion = `${bundleVersion} ${apiVersion && appVersion ? '(' + apiVersion +' '+ appVersion + ')' : ''}`
    return {
        customerName,
        version,
        detailedVersion,
    }
}
